
import { useState } from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Sun, Zap } from "lucide-react";

interface EquipamentoPadraoProps {
  form: any;
  tipoSistema: string;
  painelImagePreview: string;
  inversorImagePreview: string;
  idPainel: string;
  idInversor: string;
  handleFileUpload: (
    e: React.ChangeEvent<HTMLInputElement>, 
    setFile: (file: File | null) => void, 
    setPreview: (url: string) => void, 
    onChange: (value: string) => void
  ) => void;
  setPainelImage: (file: File | null) => void;
  setInversorImage: (file: File | null) => void;
}

export const EquipamentoPadrao = ({ 
  form, 
  tipoSistema,
  painelImagePreview,
  inversorImagePreview,
  idPainel,
  idInversor,
  handleFileUpload,
  setPainelImage,
  setInversorImage
}: EquipamentoPadraoProps) => {
  return (
    <div className="space-y-6 mt-8">
      <div>
        <h3 className="text-lg font-semibold flex items-center gap-2">
          <Sun className="h-5 w-5" /> Painel Padrão
        </h3>
        <p className="text-sm text-muted-foreground mb-4">
          Configure o painel padrão que será exibido nas propostas comerciais
        </p>
        
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <FormField
            control={form.control}
            name="marcaPadraoPainel"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Marca Padrão</FormLabel>
                <FormControl>
                  <Input {...field} placeholder="Canadian Solar, JinkoSolar, etc." />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="modeloPadraoPainel"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Modelo Padrão</FormLabel>
                <FormControl>
                  <Input {...field} placeholder="CS3N-395MS, Tiger Neo, etc." />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        
        <div className="mt-4">
          <FormField
            control={form.control}
            name="fotoPadraoPainel"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Imagem do Painel</FormLabel>
                <FormControl>
                  <div className="grid gap-4">
                    <Input
                      id={idPainel}
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileUpload(
                        e, 
                        setPainelImage, 
                        (url) => {
                          field.onChange(url);
                        },
                        field.onChange
                      )}
                    />
                    {painelImagePreview && (
                      <div className="relative aspect-video w-full max-w-sm overflow-hidden rounded-lg">
                        <img
                          src={painelImagePreview}
                          alt="Preview do painel"
                          className="h-full w-full object-cover"
                        />
                      </div>
                    )}
                  </div>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
      
      <div>
        <h3 className="text-lg font-semibold flex items-center gap-2 mt-6">
          <Zap className="h-5 w-5" /> Inversor Padrão
        </h3>
        <p className="text-sm text-muted-foreground mb-4">
          Configure o inversor padrão que será exibido nas propostas comerciais
        </p>
        
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <FormField
            control={form.control}
            name="marcaPadraoInversor"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Marca Padrão</FormLabel>
                <FormControl>
                  <Input {...field} placeholder="Growatt, Fronius, etc." />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="modeloPadraoInversor"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Modelo Padrão</FormLabel>
                <FormControl>
                  <Input {...field} placeholder="MIN 3000TL-X, Primo, etc." />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        
        <div className="mt-4">
          <FormField
            control={form.control}
            name="fotoPadraoInversor"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Imagem do Inversor</FormLabel>
                <FormControl>
                  <div className="grid gap-4">
                    <Input
                      id={idInversor}
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileUpload(
                        e, 
                        setInversorImage, 
                        (url) => {
                          field.onChange(url);
                        },
                        field.onChange
                      )}
                    />
                    {inversorImagePreview && (
                      <div className="relative aspect-video w-full max-w-sm overflow-hidden rounded-lg">
                        <img
                          src={inversorImagePreview}
                          alt="Preview do inversor"
                          className="h-full w-full object-cover"
                        />
                      </div>
                    )}
                  </div>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
    </div>
  );
};
